<div class="ag-summation-panel" [ngStyle]="{'--panel-width': width + 'px'}">
  @if (display) {
    <label>{{label}}@if (label) {
      <span>:</span>
    } {{sum | number}}</label>
  }
</div>
